/**
 * @generated SignedSource<<fc5a8a1de34cf3f0f96e1150f9ec4b49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FolderItemContentInput = {
  bridge?: BridgeInput | null;
  file?: FileInput | null;
  form?: FormInput | null;
  label?: string | null;
  page?: PageInput | null;
  published: boolean;
};
export type BridgeInput = {
  description?: string | null;
  imageUrl?: URIString | null;
  internal?: BridgeInput_InternalInputType | null;
  name: string;
  title?: string | null;
  url: URIString;
};
export type BridgeInput_InternalInputType = {
  nodeId?: string | null;
};
export type FileInput = {
  uploadToken: string;
};
export type FormInput = {
  questions?: ReadonlyArray<FormQuestionInput> | null;
  title: string;
};
export type FormQuestionInput = {
  addressDefinition?: CustomField__AddressInput | null;
  checkboxesDefinition?: CustomField__CheckboxesInput | null;
  checkboxesGridDefinition?: CustomField__CheckboxesGridInput | null;
  dateDefinition?: CustomField__DateInput | null;
  dateTimeDefinition?: CustomField__DateTimeInput | null;
  emailDefinition?: CustomField__EmailInput | null;
  formattedTextDefinition?: CustomField__FormattedTextInput | null;
  keywordsDefinition?: CustomField__KeywordsInput | null;
  linkDefinition?: CustomField__LinkInput | null;
  multipleChoiceDefinition?: CustomField__MultipleChoiceInput | null;
  multipleChoiceGridDefinition?: CustomField__MultipleChoiceGridInput | null;
  numericDefinition?: CustomField__NumericInput | null;
  phoneNumberDefinition?: CustomField__PhoneNumberInput | null;
  required: boolean;
  stringDefinition?: CustomField__StringInput | null;
  text: string;
  timeDefinition?: CustomField__TimeInput | null;
};
export type CustomField__AddressInput = {
  dummy?: boolean | null;
};
export type CustomField__CheckboxesInput = {
  options: ReadonlyArray<CustomField__CheckboxOptionInput>;
};
export type CustomField__CheckboxOptionInput = {
  text: string;
  value?: string | null;
};
export type CustomField__CheckboxesGridInput = {
  options: ReadonlyArray<CustomField__CheckboxesGridOptionInput>;
  rows: ReadonlyArray<CustomField__CheckboxesGridRowInput>;
};
export type CustomField__CheckboxesGridOptionInput = {
  text: string;
  value?: string | null;
};
export type CustomField__CheckboxesGridRowInput = {
  text: string;
  value?: string | null;
};
export type CustomField__DateInput = {
  maxDate?: any | null;
  minDate?: any | null;
};
export type CustomField__DateTimeInput = {
  maxDatetime?: ISO8601DateTimeString | null;
  minDatetime?: ISO8601DateTimeString | null;
};
export type CustomField__EmailInput = {
  maxLength?: number | null;
};
export type CustomField__FormattedTextInput = {
  maxLength?: number | null;
};
export type CustomField__KeywordsInput = {
  maxCount?: number | null;
};
export type CustomField__LinkInput = {
  maxLength?: number | null;
};
export type CustomField__MultipleChoiceInput = {
  options: ReadonlyArray<CustomField__MultipleChoiceOptionInput>;
};
export type CustomField__MultipleChoiceOptionInput = {
  text: string;
  value?: string | null;
};
export type CustomField__MultipleChoiceGridInput = {
  options: ReadonlyArray<CustomField__MultipleChoiceGridOptionInput>;
  rows: ReadonlyArray<CustomField__MultipleChoiceGridRowInput>;
};
export type CustomField__MultipleChoiceGridOptionInput = {
  text: string;
  value?: string | null;
};
export type CustomField__MultipleChoiceGridRowInput = {
  text: string;
  value?: string | null;
};
export type CustomField__NumericInput = {
  maxValue: number;
  minValue: number;
};
export type CustomField__PhoneNumberInput = {
  maxLength?: number | null;
  minLength?: number | null;
};
export type CustomField__StringInput = {
  maxLength?: number | null;
};
export type CustomField__TimeInput = {
  maxTime?: TimeOfDayString | null;
  minTime?: TimeOfDayString | null;
};
export type PageInput = {
  data?: string | null;
  title: string;
};
export type DuplicateOption_createFolderItems_Mutation$variables = {
  connections: ReadonlyArray<string>;
  contents: ReadonlyArray<FolderItemContentInput>;
  parentFolderId: string;
};
export type DuplicateOption_createFolderItems_Mutation$data = {
  readonly createFolderItems: {
    readonly folderItemsAdded: ReadonlyArray<{
      readonly content: {
        readonly id?: string;
      };
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ItemMenu_node">;
    }>;
  } | null;
};
export type DuplicateOption_createFolderItems_Mutation = {
  response: DuplicateOption_createFolderItems_Mutation$data;
  variables: DuplicateOption_createFolderItems_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contents"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentFolderId"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "contents",
        "variableName": "contents"
      },
      {
        "kind": "Variable",
        "name": "parentFolderId",
        "variableName": "parentFolderId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "kind": "InlineFragment",
  "selections": (v5/*: any*/),
  "type": "Form",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v5/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v9 = {
  "kind": "InlineFragment",
  "selections": (v5/*: any*/),
  "type": "PendingFile",
  "abstractKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    (v17/*: any*/),
    (v14/*: any*/)
  ],
  "type": "File",
  "abstractKey": null
},
v19 = [
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v17/*: any*/)
    ],
    "type": "File",
    "abstractKey": null
  },
  (v8/*: any*/),
  (v9/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canDelete",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishState",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "data",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      (v23/*: any*/)
    ],
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v26 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 1
  }
],
v27 = [
  (v12/*: any*/)
],
v28 = {
  "alias": "canEdit",
  "args": null,
  "concreteType": "AuthorizationResult",
  "kind": "LinkedField",
  "name": "canUpdate",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": "implementsPermissions",
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Thumbnail",
  "kind": "LinkedField",
  "name": "thumbnail",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v31 = [
  (v30/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          (v4/*: any*/),
          (v12/*: any*/),
          (v17/*: any*/),
          (v14/*: any*/)
        ],
        "type": "File",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "modules",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canCreateAnnouncement",
          "plural": false,
          "selections": (v11/*: any*/),
          "storageKey": null
        }
      ],
      "type": "SpaceAnnouncementsModule",
      "abstractKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastModifiedAt",
  "storageKey": null
},
v35 = {
  "alias": "announcementSpace",
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v4/*: any*/),
    (v32/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v37 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      (v10/*: any*/),
      (v23/*: any*/)
    ],
    "storageKey": null
  }
],
v38 = [
  (v4/*: any*/),
  (v14/*: any*/)
],
v39 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Pin",
      "kind": "LinkedField",
      "name": "pins",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "context",
          "storageKey": null
        },
        (v4/*: any*/),
        (v36/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "HasPinsInterface",
  "abstractKey": "__isHasPinsInterface"
},
v40 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FolderNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "Folder",
            "abstractKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DuplicateOption_createFolderItems_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "FilesAndFoldersCreateFolderItemsMutationPayload",
        "kind": "LinkedField",
        "name": "createFolderItems",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FolderItem",
            "kind": "LinkedField",
            "name": "folderItemsAdded",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ItemMenu_node"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DuplicateOption_createFolderItems_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "FilesAndFoldersCreateFolderItemsMutationPayload",
        "kind": "LinkedField",
        "name": "createFolderItems",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FolderItem",
            "kind": "LinkedField",
            "name": "folderItemsAdded",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canUpdateTags",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "HasTagsInterface",
                    "abstractKey": "__isHasTagsInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cover",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VaultUploadGroup",
                        "kind": "LinkedField",
                        "name": "uploadGroup",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "publisher",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "roles",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DateTime",
                            "kind": "LinkedField",
                            "name": "publishedAt",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "utcDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "utcTime",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "vaultItemContent",
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      {
                        "alias": "isVaultItem",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "alias": "canSeeVaultItemPermissions",
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canDelete",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "VaultItem",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isNew",
                        "storageKey": null
                      }
                    ],
                    "type": "IsNewInterface",
                    "abstractKey": "__isIsNewInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuthorizationResult",
                            "kind": "LinkedField",
                            "name": "canPublish",
                            "plural": false,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          },
                          (v21/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v4/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "type": "Page",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FormQuestion",
                                        "kind": "LinkedField",
                                        "name": "questions",
                                        "plural": true,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "definition",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v4/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v24/*: any*/),
                                                "type": "CustomField__Checkboxes",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v24/*: any*/),
                                                "type": "CustomField__MultipleChoice",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Form",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v12/*: any*/),
                              (v25/*: any*/)
                            ],
                            "type": "FolderItem",
                            "abstractKey": null
                          }
                        ],
                        "type": "FolderNodeInterface",
                        "abstractKey": "__isFolderNodeInterface"
                      }
                    ],
                    "type": "FolderNode",
                    "abstractKey": "__isFolderNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberFavourite",
                        "kind": "LinkedField",
                        "name": "favourite",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "FavouritedInterface",
                    "abstractKey": "__isFavouritedInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "ownershipSpace",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuthorizationResult",
                            "kind": "LinkedField",
                            "name": "canModifySpaceShortcuts",
                            "plural": false,
                            "selections": (v11/*: any*/),
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "ownershipEvent",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v26/*: any*/),
                        "concreteType": "FolderConnection",
                        "kind": "LinkedField",
                        "name": "ownershipFolders",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Folder",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": "ownershipFolders(last:1)"
                      }
                    ],
                    "type": "HasOwnerPermissionsInterface",
                    "abstractKey": "__isHasOwnerPermissionsInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "announcementDate",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "publishedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Member",
                        "kind": "LinkedField",
                        "name": "announcer",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnnouncementLink",
                        "kind": "LinkedField",
                        "name": "link",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v27/*: any*/),
                                    "type": "Event",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v27/*: any*/),
                                    "type": "Folder",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v27/*: any*/),
                                    "type": "FolderItem",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v27/*: any*/),
                                            "type": "File",
                                            "abstractKey": null
                                          },
                                          (v8/*: any*/),
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "AnnouncementAttachment",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v28/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pinned",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canPin",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canUnpin",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      (v29/*: any*/)
                    ],
                    "type": "Announcement",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v31/*: any*/),
                    "type": "AnnouncementAttachment",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v31/*: any*/),
                    "type": "MemberDetailsAttachment",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          (v32/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v30/*: any*/),
                      (v21/*: any*/),
                      (v35/*: any*/),
                      (v29/*: any*/),
                      {
                        "alias": "canUpdateThumbnail",
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canRename",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Folder",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v36/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              (v22/*: any*/)
                            ],
                            "type": "Page",
                            "abstractKey": null
                          },
                          (v18/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormQuestion",
                                "kind": "LinkedField",
                                "name": "questions",
                                "plural": true,
                                "selections": [
                                  (v4/*: any*/),
                                  (v23/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "required",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v4/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v37/*: any*/),
                                        "type": "CustomField__Checkboxes",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "maxValue",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "minValue",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "CustomField__Numeric",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v37/*: any*/),
                                        "type": "CustomField__MultipleChoice",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Form",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v38/*: any*/),
                            "type": "ExternalBridge",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v38/*: any*/),
                            "type": "InternalBridge",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v15/*: any*/),
                            "type": "BridgeInterface",
                            "abstractKey": "__isBridgeInterface"
                          }
                        ],
                        "storageKey": null
                      },
                      (v30/*: any*/),
                      {
                        "alias": "folderItemContent",
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      (v35/*: any*/),
                      {
                        "alias": "canEdit",
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canRename",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      (v29/*: any*/),
                      (v39/*: any*/)
                    ],
                    "type": "FolderItem",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SignatureEnvelope",
                        "kind": "LinkedField",
                        "name": "signatureEnvelope",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canCreateSignatureEnvelope",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "SignableInterface",
                    "abstractKey": "__isSignableInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v21/*: any*/),
                      (v35/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CoverImage",
                        "kind": "LinkedField",
                        "name": "coverImage",
                        "plural": false,
                        "selections": (v15/*: any*/),
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v28/*: any*/),
                      (v25/*: any*/),
                      (v29/*: any*/)
                    ],
                    "type": "Event",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v16/*: any*/)
                    ],
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v30/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canUpdate",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "isVault",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "alias": "canUpdateThumbnail",
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canUpdate",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Vault",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Color",
                        "kind": "LinkedField",
                        "name": "color",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "light",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dark",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Space",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canUpdateSecurity",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "preventDownload",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasWatermark",
                        "storageKey": null
                      }
                    ],
                    "type": "HasNodeSecurityInterface",
                    "abstractKey": "__isHasNodeSecurityInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "draftVaultItemContent",
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "VaultDraftItem",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canonicalUrl",
                        "storageKey": null
                      }
                    ],
                    "type": "HasCanonicalUrlInterface",
                    "abstractKey": "__isHasCanonicalUrlInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v21/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canRename",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuthorizationResult",
                        "kind": "LinkedField",
                        "name": "canMove",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "root",
                        "args": (v26/*: any*/),
                        "concreteType": "FolderNodeConnection",
                        "kind": "LinkedField",
                        "name": "ancestors",
                        "plural": false,
                        "selections": (v40/*: any*/),
                        "storageKey": "ancestors(last:1)"
                      },
                      {
                        "alias": "parent",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "depth",
                            "value": 1
                          }
                        ],
                        "concreteType": "FolderNodeConnection",
                        "kind": "LinkedField",
                        "name": "ancestors",
                        "plural": false,
                        "selections": (v40/*: any*/),
                        "storageKey": "ancestors(depth:1)"
                      }
                    ],
                    "type": "FolderNodeInterface",
                    "abstractKey": "__isFolderNodeInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v30/*: any*/)
                    ],
                    "type": "HasThumbnailInterface",
                    "abstractKey": "__isHasThumbnailInterface"
                  },
                  (v39/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "folderItemsAdded",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "FolderNodeEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f576f2dd747ad0bb910d78b3ea4c26b1",
    "id": null,
    "metadata": {},
    "name": "DuplicateOption_createFolderItems_Mutation",
    "operationKind": "mutation",
    "text": "mutation DuplicateOption_createFolderItems_Mutation(\n  $parentFolderId: ID!\n  $contents: [FolderItemContentInput!]!\n) {\n  createFolderItems(input: {parentFolderId: $parentFolderId, contents: $contents}) {\n    folderItemsAdded {\n      id\n      content {\n        __typename\n        ... on Form {\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on PendingFile {\n          id\n        }\n      }\n      ...ItemMenu_node\n    }\n  }\n}\n\nfragment AccessOption_node on Node {\n  __isNode: __typename\n  id\n  ... on Event {\n    implementsPermissions: __typename\n  }\n  ... on FolderItem {\n    implementsPermissions: __typename\n  }\n  ... on Folder {\n    implementsPermissions: __typename\n  }\n  ... on Announcement {\n    implementsPermissions: __typename\n  }\n  ... on VaultItem {\n    isVaultItem: __typename\n    canSeeVaultItemPermissions: canDelete {\n      value\n    }\n  }\n  ... on Vault {\n    isVault: __typename\n  }\n}\n\nfragment AnnounceOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on Folder {\n    space {\n      __typename\n      id\n      modules {\n        __typename\n        ... on SpaceAnnouncementsModule {\n          canCreateAnnouncement {\n            value\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AnnouncementButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on Folder {\n    publishState\n    announcementSpace: space {\n      __typename\n      id\n      modules {\n        __typename\n        ... on SpaceAnnouncementsModule {\n          canCreateAnnouncement {\n            value\n          }\n        }\n        id\n      }\n    }\n  }\n  ... on FolderItem {\n    publishState\n    announcementSpace: space {\n      __typename\n      id\n      modules {\n        __typename\n        ... on SpaceAnnouncementsModule {\n          canCreateAnnouncement {\n            value\n          }\n        }\n        id\n      }\n    }\n  }\n  ... on Event {\n    publishState\n    announcementSpace: space {\n      __typename\n      id\n      modules {\n        __typename\n        ... on SpaceAnnouncementsModule {\n          canCreateAnnouncement {\n            value\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment CopyLinkButton_node on Node {\n  __isNode: __typename\n  ... on HasCanonicalUrlInterface {\n    __isHasCanonicalUrlInterface: __typename\n    canonicalUrl\n  }\n}\n\nfragment CreateShortcutOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipSpace {\n      id\n      canModifySpaceShortcuts {\n        value\n      }\n      ...ManageSpaceShortcutModal_space\n    }\n    ownershipEvent {\n      id\n    }\n    ownershipFolders(last: 1) {\n      nodes {\n        id\n      }\n    }\n  }\n  ... on HasThumbnailInterface {\n    __isHasThumbnailInterface: __typename\n    thumbnail {\n      url\n    }\n  }\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    name\n    publishState\n  }\n  ... on FolderItem {\n    content {\n      __typename\n      ... on File {\n        id\n        url\n        mimeType\n      }\n      ... on BridgeInterface {\n        __isBridgeInterface: __typename\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on Event {\n    name\n    publishState\n    coverImage {\n      url\n    }\n  }\n}\n\nfragment DeleteNodeOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    canDelete {\n      value\n    }\n    name\n  }\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipEvent {\n      id\n    }\n  }\n  ... on Event {\n    name\n    canDelete {\n      value\n    }\n    space {\n      id\n    }\n  }\n  ... on Announcement {\n    canDelete {\n      value\n    }\n  }\n  ... on VaultItem {\n    canDelete {\n      value\n    }\n  }\n}\n\nfragment DownloadButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ...useItemHandleFragment\n  ...useNodeSecurity_node\n  ... on FolderItem {\n    content {\n      __typename\n      ... on File {\n        id\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    content {\n      __typename\n      ... on File {\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n\nfragment DuplicateOption_node on Node {\n  __isNode: __typename\n  __typename\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    parent: ancestors(depth: 1) {\n      edges {\n        node {\n          __typename\n          ... on Folder {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  ... on FolderItem {\n    id\n    name\n    content {\n      __typename\n      ... on Form {\n        id\n        questions {\n          id\n          text\n          required\n          definition {\n            __typename\n            id\n            ... on CustomField__Checkboxes {\n              options {\n                value\n                text\n              }\n            }\n            ... on CustomField__Numeric {\n              maxValue\n              minValue\n            }\n            ... on CustomField__MultipleChoice {\n              options {\n                value\n                text\n              }\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n\nfragment EditOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on Announcement {\n    canEdit: canUpdate {\n      value\n    }\n  }\n  ... on Event {\n    canEdit: canUpdate {\n      value\n    }\n  }\n  ... on FolderItem {\n    canEdit: canRename {\n      value\n    }\n    content {\n      __typename\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n\nfragment EditableFolderItemMenu_folderItemNode on FolderNodeInterface {\n  __isFolderNodeInterface: __typename\n  __typename\n  canPublish {\n    value\n  }\n  publishState\n  ... on FolderItem {\n    id\n    content {\n      __typename\n      ... on Page {\n        id\n        data\n      }\n      ... on Form {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n    ...PublishFolderItemDialog_folderItem\n  }\n}\n\nfragment FavouriteButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on FavouritedInterface {\n    __isFavouritedInterface: __typename\n    favourite {\n      id\n    }\n  }\n}\n\nfragment ItemMenu_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ...TagButton_node\n  ...TagsButton_node\n  ...Status_node\n  ...FavouriteButton_node\n  ...DownloadButton_node\n  ...ShareButton_node\n  ...EditOption_node\n  ...RenameOption_node\n  ...MoveOption_node\n  ...DeleteNodeOption_node\n  ...PinOption_node\n  ...DuplicateOption_node\n  ...AnnounceOption_node\n  ...CreateShortcutOption_node\n  ...AccessOption_node\n  ...ManageVaultFieldsOption_node\n  ...RequestSignaturesOption_node\n  ...ThumbnailOption_node\n  ...MarkAsOption_node\n}\n\nfragment ManageSpaceShortcutModal_space on Space {\n  __typename\n  id\n}\n\nfragment ManageVaultFieldsOption_node on Node {\n  __isNode: __typename\n  id\n  ... on Vault {\n    __typename\n    canUpdate {\n      value\n    }\n  }\n}\n\nfragment MarkAsOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasPinsInterface {\n    __isHasPinsInterface: __typename\n    pins {\n      context\n      id\n      label\n    }\n  }\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipEvent {\n      id\n    }\n  }\n}\n\nfragment MoveOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    canMove {\n      value\n    }\n    root: ancestors(last: 1) {\n      edges {\n        node {\n          __typename\n          ... on Folder {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment PinOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on Announcement {\n    pinned\n    canPin {\n      value\n    }\n    canUnpin {\n      value\n    }\n  }\n}\n\nfragment PublishFolderItemDialog_folderItem on FolderItem {\n  id\n  name\n  content {\n    __typename\n    ... on Page {\n      id\n      data\n    }\n    ... on Form {\n      id\n      questions {\n        id\n        definition {\n          __typename\n          id\n          ... on CustomField__Checkboxes {\n            options {\n              text\n            }\n          }\n          ... on CustomField__MultipleChoice {\n            options {\n              text\n            }\n          }\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on PendingFile {\n      id\n    }\n  }\n  space {\n    id\n  }\n}\n\nfragment ReminderButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    publishState\n    canDelete {\n      value\n    }\n  }\n  ... on FolderItem {\n    content {\n      __typename\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    canDelete {\n      value\n    }\n    content {\n      __typename\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on Event {\n    publishState\n    canDelete {\n      value\n    }\n  }\n}\n\nfragment RenameOption_node on Node {\n  __isNode: __typename\n  id\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    __typename\n    name\n    canRename {\n      value\n    }\n  }\n  ... on Vault {\n    __typename\n    name\n    canUpdate {\n      value\n    }\n  }\n}\n\nfragment RequestSignaturesOption_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on SignableInterface {\n    __isSignableInterface: __typename\n    canCreateSignatureEnvelope {\n      value\n    }\n    signatureEnvelope {\n      id\n      status\n    }\n  }\n}\n\nfragment ShareButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ...CopyLinkButton_node\n  ...WebShareButton_node\n  ...DownloadButton_node\n  ...AnnouncementButton_node\n  ...ShortcutButton_node\n  ...ReminderButton_node\n}\n\nfragment ShortcutButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipSpace {\n      id\n      canModifySpaceShortcuts {\n        value\n      }\n      ...ManageSpaceShortcutModal_space\n    }\n    ownershipEvent {\n      id\n    }\n    ownershipFolders(last: 1) {\n      nodes {\n        id\n      }\n    }\n  }\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    name\n    publishState\n  }\n  ... on FolderItem {\n    content {\n      __typename\n      ... on File {\n        id\n        url\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on Event {\n    name\n    publishState\n    coverImage {\n      url\n    }\n  }\n}\n\nfragment Status_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on VaultItem {\n    cover\n  }\n  ... on IsNewInterface {\n    __isIsNewInterface: __typename\n    isNew\n  }\n  ... on FolderNode {\n    __isFolderNode: __typename\n    ...EditableFolderItemMenu_folderItemNode\n  }\n}\n\nfragment TagButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasTagsInterface {\n    __isHasTagsInterface: __typename\n    tags {\n      id\n    }\n    canUpdateTags {\n      value\n    }\n  }\n}\n\nfragment TagsButton_node on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasTagsInterface {\n    __isHasTagsInterface: __typename\n    tags {\n      id\n    }\n  }\n  ...TagButton_node\n}\n\nfragment ThumbnailOption_node on Node {\n  __isNode: __typename\n  id\n  ... on Folder {\n    canUpdateThumbnail: canRename {\n      value\n    }\n  }\n  ... on Vault {\n    canUpdateThumbnail: canUpdate {\n      value\n    }\n  }\n  ... on HasThumbnailInterface {\n    __isHasThumbnailInterface: __typename\n    __typename\n    thumbnail {\n      url\n    }\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n\nfragment VaultItemAccessDetails_node on VaultItem {\n  id\n  uploadGroup {\n    publisher {\n      id\n      ...UserHandle_member\n    }\n    publishedAt {\n      utcDate\n      utcTime\n    }\n    id\n  }\n}\n\nfragment WebShareButton_node on Node {\n  __isNode: __typename\n  ... on HasCanonicalUrlInterface {\n    __isHasCanonicalUrlInterface: __typename\n    canonicalUrl\n  }\n  ... on FolderNodeInterface {\n    __isFolderNodeInterface: __typename\n    __typename\n    name\n  }\n  ... on Event {\n    __typename\n    name\n  }\n  ... on Vault {\n    __typename\n    name\n  }\n  ... on VaultItem {\n    __typename\n    name\n  }\n  ... on Space {\n    __typename\n    name\n  }\n  ... on Announcement {\n    __typename\n  }\n}\n\nfragment useItemHandleFragment on Node {\n  __isNode: __typename\n  __typename\n  id\n  ... on HasOwnerPermissionsInterface {\n    __isHasOwnerPermissionsInterface: __typename\n    ownershipSpace {\n      id\n    }\n    ownershipEvent {\n      id\n    }\n    ownershipFolders(last: 1) {\n      nodes {\n        id\n      }\n    }\n  }\n  ... on Announcement {\n    announcementDate: publishedAt\n    announcer {\n      id\n      name\n    }\n    link {\n      item {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n          ... on Event {\n            name\n          }\n          ... on Folder {\n            name\n          }\n          ... on FolderItem {\n            name\n          }\n          ... on AnnouncementAttachment {\n            content {\n              __typename\n              ... on File {\n                name\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n              ... on PendingFile {\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n  ... on AnnouncementAttachment {\n    thumbnail {\n      url\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        mimeType\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on MemberDetailsAttachment {\n    thumbnail {\n      url\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        name\n        mimeType\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Folder {\n    name\n    space {\n      id\n    }\n    publishedAt\n    lastModifiedAt\n    thumbnail {\n      url\n    }\n  }\n  ... on FolderItem {\n    name\n    label\n    publishedAt\n    lastModifiedAt\n    content {\n      __typename\n      ... on Page {\n        id\n        title\n        data\n      }\n      ... on File {\n        id\n        mimeType\n        url\n      }\n      ... on PendingFile {\n        id\n      }\n      ... on Form {\n        id\n        questions {\n          id\n          text\n        }\n      }\n      ... on ExternalBridge {\n        id\n        url\n      }\n      ... on InternalBridge {\n        id\n        url\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    thumbnail {\n      url\n    }\n    ... on HasPinsInterface {\n      __isHasPinsInterface: __typename\n      pins {\n        context\n        id\n        label\n      }\n    }\n  }\n  ... on SignableInterface {\n    __isSignableInterface: __typename\n    signatureEnvelope {\n      id\n      status\n    }\n  }\n  ... on VaultItem {\n    ...VaultItemAccessDetails_node\n    name\n    uploadGroup {\n      publishedAt {\n        utcDate\n        utcTime\n      }\n      publisher {\n        name\n        id\n      }\n      id\n    }\n    content {\n      __typename\n      ... on File {\n        id\n        mimeType\n        url\n      }\n      ... on PendingFile {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ... on Event {\n    name\n  }\n  ... on Member {\n    name\n    ...UserAvatar_member\n  }\n  ... on Vault {\n    name\n    thumbnail {\n      url\n    }\n  }\n  ... on Space {\n    name\n    color {\n      light\n      dark\n    }\n  }\n}\n\nfragment useNodeSecurity_node on Node {\n  __isNode: __typename\n  id\n  ... on HasNodeSecurityInterface {\n    __isHasNodeSecurityInterface: __typename\n    canUpdateSecurity {\n      value\n    }\n    preventDownload\n    hasWatermark\n  }\n  ... on FolderItem {\n    folderItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultItem {\n    vaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n  ... on VaultDraftItem {\n    draftVaultItemContent: content {\n      __typename\n      ... on File {\n        mimeType\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on PendingFile {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0653823d2b4d16f1e31ec5968a56349f";

export default node;
